module.exports = __webpack_public_path__ + "static/media/custom-wed-01.c6095d95.jpg";